import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';
import { TERMS_OF_USE } from '../content/legalContent';

const TermsPage = () => (
  <LegalPageLayout document={TERMS_OF_USE} activePath="/terms" />
);

export default TermsPage;
